import React from 'react';
import flex from '@/css/module/flex.css';
import { TrevorIcon } from '@trevor/ui-components';
import LastRefreshed from '@/components/LastRefreshed';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from 'react-redux';
import { getDashboardsState } from '@/store-selectors';

export const PublicDashboardHeader: React.FC<{
  width: number;
  onFullScreen: F0;
}> = ({ width, onFullScreen }) => {
  const dashboardState = useSelector(getDashboardsState);
  return (
    <div className="dashboard-header">
      <div className={`${flex.alignItemsCenter} logoContainer`}>
        <a href="https://trevor.io">
          <TrevorIcon name="logo-symbol" height="30.32" width="24" />
        </a>
      </div>
      <div className={`${flex.alignItemsCenter} dashboard-control-container`}>
        <span style={{ fontWeight: '600' }}>
          {dashboardState.active?.name()}
        </span>
      </div>
      <div className={flex.alignItemsCenter} style={{ width: '220px' }}>
        {dashboardState.chartWidgets && (
          <span className="small faint margin-left-5 margin-right-5">
            Last refreshed:{' '}
            {!dashboardState.lastRefreshed ? (
              'Never'
            ) : (
              <LastRefreshed lastRefreshed={dashboardState.lastRefreshed} />
            )}
          </span>
        )}
        {width < 450 || dashboardState.isSnapshot ? null : (
          <button
            className="btn hide-on-mobile btn-outline-dark btn-sm"
            type="button"
            onClick={onFullScreen}
          >
            <FontAwesomeIcon icon="expand-arrows-alt" />
          </button>
        )}
      </div>
    </div>
  );
};
